import ErrorStackParser from 'error-stack-parser';

export class NotFoundError extends Error {
  constructor(message = 'Not found') {
    super(message);
    this.name = 'NotFoundError';
  }
}

export default function ensureError(value: unknown): Error {
  if (value instanceof Error) return value;

  // Handle react-router's internal not found error
  if (
    value &&
    typeof value === 'object' &&
    'status' in value &&
    value.status === 404
  ) {
    let message = 'Not Found';
    if ('statusText' in value && typeof value.statusText === 'string')
      message = value.statusText;
    return new NotFoundError(message);
  }

  let stringified = '[Unable to stringify thrown value]';
  try {
    stringified = JSON.stringify(value);
  } catch {}

  return new Error(stringified);
}

const SOURCE_MARKER = '/src/';
const MAX_STACK_FRAMES = 5;

export function formatErrorForNotification(error: Error): string {
  const frames = ErrorStackParser.parse(error);

  const ownFrames = frames
    .filter((f) => f.fileName?.includes(SOURCE_MARKER))
    .slice(0, MAX_STACK_FRAMES);

  const stackStr = ownFrames
    .map((f) => {
      const file = f.fileName?.split(SOURCE_MARKER)[1] ?? f.fileName ?? '?';
      return `>     ${f.functionName ?? '?'} (${file}:${f.lineNumber})`;
    })
    .join('\n');

  return `> ${error.name}: ${error.message}\n${stackStr}`;
}
